export const PROXY_URL_MAP: Record<string, string> = {
  LOKI_ERROR: '/api/loki/error',
} as const
